const LanguageStorageKey = 'SOFTCAT_USER_LANGUAGE';
const TerritoryStorageKey = 'SOFTCAT_USER_TERRITORY';

export const UserPreferencesConfig = {
    LanguageStorageKey,
    TerritoryStorageKey,
};
